module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/create.js
// module id = 209
// module chunks = 35783957827783 52252321336229